import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router'

// Components
import { App } from '../../../App';
import { ModelList } from '../../../components/PaginatedList/ModelList';


// Redux
import { FullViews } from './redux/views.selectors';
import { hasAccess } from '../../services/CaptureCollabService';
import { SmartContainer, StyledGridItem, Surface } from '../../../styles/Containers';
import { StyledP } from '../../../styles/StyledHTML';
import { ViewsList } from './ViewsList';

export const ViewsPage = () => {

    // New Modal
    const dispatch = useDispatch();
    const store = FullViews();

    // --------------------------
    // Interactions
    // --------------------------

    // On Select
    const handleSelect = (item) => {
        dispatch(push(`/views/${item.id}`))
    }

    // Render Page
    return (
        <App title="Views">

            <StyledP>Views are a saved set of Filters. Create new Views by searching photos and then saving the filters.</StyledP>

            <ViewsList onSelect={handleSelect} />

        </App>
    )
}